export default __webpack_public_path__ + "static/media/nDeposit.6e17207d.svg";